import { useRuntime } from "./useRuntime";
export var useBrand = function() {
    var brand = useRuntime().brand;
    return brand;
};
